import React from "react";
import "../styles/layout/LandingPage.scss";
import { Box, Card, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const expertiseData = [
  {
    title: "Data\nAnalytics",
    description:
      "Converting raw data into meaningful insights for informed decision-making",
    link: "/DataAnalytics",
    imgSrc: "/assets/ourExpertise/dataAnalyst.webp",
    reverse: false,
  },
  {
    title: "AI & Machine Learning",
    description:
      "Building intelligent systems to automate and optimize processes.",
    link: "/AIML",
    imgSrc: "/assets/ourExpertise/AI.webp",
    reverse: true,
  },
  {
    title: "Predictive\nModelling",
    description:
      "Anticipating trends and behaviours to empower proactive strategies",
    link: "/AI_PredictiveAnalysis",
    imgSrc: "/assets/ourExpertise/PM.webp",
    reverse: false,
  },
  {
    title: "Big Data Management",
    description:
      "Efficiently handling, storing, and analyzing large-scale datasets",
    link: "/BigData",
    imgSrc: "/assets/ourExpertise/BD.webp",
    reverse: true,
  },
  {
    title: "Custom\nSolutions",
    description:
      "Tailoring analytics tools and platforms to meet unique business needs.",
    link: "/ProductEngineering",
    imgSrc: "/assets/ourExpertise/CS.webp",
    reverse: false,
  },
];

const ExpertiseCard2 = ({ title, description, link, imgSrc, reverse }) => (
  <Card
    sx={{
      display: "flex",
      flexDirection: {
        xs: "column-reverse",
        md: reverse ? "row-reverse" : "row",
      },
      gap: "20px",
      background: "transparent",
      boxShadow: "none",
      alignItems: "center",
      margin: { xs: "0 0 5% 0", md: reverse ? "0 5% 5% 0" : "0 0 5% 5%" },
    }}
  >
    <Box
      sx={{
        flex: 1,
        textAlign: "center",
        padding: { xs: "5%", md: "5%" },
      }}
    >
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontSize: { xs: "30px", sm: "40px", md: "50px" },
          fontWeight: "800",
          color: "#000",
          letterSpacing: "2px",
          padding: "5%",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontSize: { xs: "16px", sm: "20px", md: "25px" },
          fontWeight: "lighter",
          color: "#000",
        }}
      >
        {description}
      </Typography>
      <Link
        to={link}
        style={{
          textDecoration: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "20px auto",
          width: "265px", // Adjust for responsiveness

          height: "69px", // Smaller on mobile
          background: "linear-gradient(180deg, #FF45BE , #000000  140%)",
          marginTop: "50px",
          borderRadius: "20px",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "18px", // Adjust font size for smaller screens
          border: "none",
        }}
      >
        See how
      </Link>
    </Box>
    <img
      src={imgSrc}
      alt={title}
      loading="lazy"
      style={{
        width: reverse ? "100%" : "100%", // Full width on mobile
        maxWidth: reverse ? "50%" : "55%",
        height: "auto",
      }}
    />
  </Card>
);

const ExpertiseCard1 = ({ title, description, link, imgSrc, reverse }) => (
  <Card
    sx={{
      display: "flex",
      flexDirection: {
        xs: "column-reverse",
        md: reverse ? "row-reverse" : "row",
      },
      gap: "20px",
      background: "transparent",
      boxShadow: "none",
      alignItems: "center",
      margin: { xs: "0", md: reverse ? "0 5% 5% 0" : "0 0 5% 5%" },
    }}
  >
    <Box
      sx={{
        flex: 1,
        textAlign: "center",
        padding: { xs: "5%", md: "5%" },
      }}
    >
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontSize: { xs: "30px", sm: "40px", md: "50px" },
          fontWeight: "800",
          color: "#000",
          letterSpacing: "2px",
          padding: "5%",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontSize: { xs: "16px", sm: "20px", md: "25px" },
          fontWeight: "lighter",
          color: "#000",
        }}
      >
        {description}
      </Typography>
      <Link
        to={link}
        style={{
          textDecoration: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "20px auto",
          width: "265px",
          height: "69px",
          background: "linear-gradient(180deg, #FF45BE , #000000 140%)",
          marginTop: "50px",
          borderRadius: "20px",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "18px",
          border: "none",
        }}
      >
        See how
      </Link>
    </Box>
    <Box
      sx={{
        width: { xs: "50%", md: reverse ? "50%" : "55%" }, // Keep consistent width
        height: "auto",
        alignSelf: { xs: reverse ? "flex-end" : "flex-start", md: "center" }, // Align left or right on mobile
        marginLeft: { xs: reverse ? "auto" : "0", md: reverse ? "0" : "5%" },
        marginRight: { xs: reverse ? "0" : "auto", md: reverse ? "5%" : "0" },
      }}
    >
      <img
        src={imgSrc}
        alt={title}
        loading="lazy"
        style={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
        }}
      />
    </Box>
  </Card>
);

const ExpertiseCard = ({ title, description, link, imgSrc, reverse }) => (
  <Card
    sx={{
      display: "flex",
      flexDirection: {
        xs: reverse ? "row-reverse" : "row",
        md: reverse ? "row-reverse" : "row",
      },
      
      background: "transparent",
      boxShadow: "none",
      alignItems: "center",
      margin: { xs: "0", md: reverse ? "0 5% 5% 0" : "0 0 5% 5%" },
    }}
  >
    <Box
      sx={{
        flex: 1,
        textAlign: "center",
        padding: { xs: "3%", md: "5%" }, // Reduced padding for mobile
      }}
    >
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontSize: { xs: "24px", sm: "32px", md: "50px" }, // Reduced size on xs
          fontWeight: "800",
          color: "#000",
          letterSpacing: "2px",
          padding: "3%", // Reduced padding for better spacing
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontSize: { xs: "14px", sm: "18px", md: "25px" }, // Reduced size on xs
          fontWeight: "lighter",
          color: "#000",
          lineHeight: { xs: "1.4", md: "1.6" }, // Adjust line height
        }}
      >
        {description}
      </Typography>
      <Box
        component={Link}
        to={link}
        sx={{
          textDecoration: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "20px auto",
          width: { xs: "140px", sm: "220px", md: "265px" }, // Adjust width based on screen size
          height: { xs: "45px", sm: "55px", md: "69px" }, // Adjust height based on screen size
          background: "linear-gradient(180deg, #FF45BE , #000000 140%)",
          borderRadius: "20px",
          color: "#fff",
          fontWeight: "bold",
          fontSize: { xs: "14px", sm: "16px", md: "18px" }, // Adjust font size for mobile
          border: "none",
          marginTop: { xs: "20px", md: "30px" }, // Adjust top margin for alignment
          "&:hover": {
            opacity: 0.9, // Subtle hover effect
          },
        }}
      >
        See how
      </Box>
    </Box>
    <Box
      sx={{
        width: { xs: "70%", sm: "60%", md: reverse ? "50%" : "55%" }, // Increased size on mobile
        height: "auto",
        alignSelf: "center",
        marginLeft: { xs: reverse ? "auto" : "0", md: reverse ? "0" : "5%" },
        marginRight: { xs: reverse ? "0" : "auto", md: reverse ? "5%" : "0" },
      }}
    >
      <img
        src={imgSrc}
        alt={title}
        loading="lazy"
        style={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
        }}
      />
    </Box>
  </Card>
);

const OurExpertise = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#FFEEF9",
        height: "auto",
        maxWidth: "100%",
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        gap: "2%",
    
      }}
    >
      {/* Background Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage:
            'url("/assets/header/servicesDropDownImages/OurServicesPatern.webp")',
          backgroundSize: "contain",
          backgroundPosition: "top center",
          opacity: 0.4,
          zIndex: 0,
        }}
      />

      {/* Content Container */}
      <Box sx={{ position: "relative", zIndex: 1, width: "100%" }}>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontSize: { xs: "40px", sm: "55px", md: "70px" },
            fontWeight: "800",
            color: "#000",
            letterSpacing: "2px",
            textAlign: "center",
            padding: "4%",
          }}
        >
          Our Expertise
        </Typography>

        {expertiseData.map((item, index) => (
          <ExpertiseCard key={index} {...item} />
        ))}
      </Box>
    </Box>
  );
};

export default OurExpertise;
